import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { i18n, LANGS, useT } from '../services/i18n';
import { authAPI } from '../services/api';

const Flag = ({ code, size = 18 }) => (
  <img src={`https://flagcdn.com/w40/${code}.png`} alt="" width={size} height={Math.round(size * 0.75)} className="rounded-[2px] object-cover" />
);

// Header language selector — remembers the choice and syncs the customer's document language
const LanguageSwitcher = ({ variant = 'dark' }) => {
  const { t, lang } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => { const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }; document.addEventListener('mousedown', h); return () => document.removeEventListener('mousedown', h); }, []);
  const active = LANGS.find((l) => l.code === lang) || LANGS[0];
  const choose = (code) => {
    i18n.set(code);
    setOpen(false);
    if (authAPI.isAuthenticated()) authAPI.setDocLang(code).catch(() => {});
  };
  const styles = {
    dark: ['relative hidden md:block', 'text-white hover:text-orange-400'],
    light: ['relative w-full', 'text-gray-800 hover:text-orange-600 border border-gray-300 rounded-lg px-3 py-2'],
    auth: ['absolute top-4 right-4 sm:top-6 sm:right-6', 'text-gray-700 hover:text-orange-600 bg-white border border-gray-200 shadow-sm rounded-full px-3 py-1.5'],
  };
  const [wrap, btn] = styles[variant] || styles.dark;
  return (
    <div className={wrap} ref={ref} data-testid="language-switcher">
      <button type="button" onClick={() => setOpen((o) => !o)} className={`inline-flex items-center gap-1.5 text-sm transition-colors ${btn}`} title={t('header.language')} aria-label={t('header.language')} data-testid="language-switcher-button">
        <Flag code={active.flag} /><span className="uppercase font-medium" data-testid="language-switcher-current">{active.code}</span><ChevronDown size={14} className="opacity-70" />
      </button>
      {open && (
        <div className="absolute right-0 z-[60] mt-2 w-44 rounded-md border border-gray-200 bg-white shadow-lg py-1 text-sm text-gray-800" data-testid="language-switcher-menu">
          {LANGS.map((l) => (
            <button key={l.code} type="button" onClick={() => choose(l.code)} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left hover:bg-orange-50 ${l.code === lang ? 'font-semibold text-orange-600' : ''}`} data-testid={`language-option-${l.code}`}>
              <Flag code={l.flag} size={20} /><span className="flex-1">{l.label}</span>{l.code === lang && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
